export default "__VITE_ASSET__D7QuDEa1__"